import { useQueryVitaUserByIdentityId } from '../../../services/api/vitaUserService';

export const useVitaUserData = (userId) => {
  const { data: vitaUser, isLoading: isLoadingVitaUser } = useQueryVitaUserByIdentityId(userId, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  // Get the VitaUser UUID
  let vitaUserId = null;
  try {
    vitaUserId = vitaUser?.data?.id;
    // Se vitaUser.data for um objeto aninhado, verificar outras possibilidades
    if (!vitaUserId && vitaUser?.data?.data?.id) {
      vitaUserId = vitaUser.data.data.id;
    }
  } catch (error) {
    console.error('Error accessing vitaUserId:', error);
  }

  return {
    vitaUser,
    vitaUserId,
    isLoadingVitaUser,
  };
};
